import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { Heading, Text } from './Typography';

interface AppSheetLayoutProps {
    title?: ReactNode;
    description?: ReactNode;
    meta?: ReactNode;
    footer?: ReactNode;
    className?: string;
    bodyClassName?: string;
    children: ReactNode;
}

export default function AppSheetLayout({
    title,
    description,
    meta,
    footer,
    className,
    bodyClassName,
    children,
}: AppSheetLayoutProps) {
    return (
        <div className={cn('flex h-full flex-col', className)}>
            {(title || description || meta) && (
                <div className="border-b border-border/70 bg-card/95 px-6 py-5 shadow-sm">
                    <div className="space-y-2 text-left">
                        {title && (
                            <Heading as="h2" variant="section" className="text-2xl font-semibold">
                                {title}
                            </Heading>
                        )}
                        {description && <Text variant="description">{description}</Text>}
                        {meta}
                    </div>
                </div>
            )}
            <div className={cn('flex-1', bodyClassName)}>{children}</div>
            {footer && (
                <div className="border-t border-border/70 bg-surface-muted/70 px-6 py-4">
                    {footer}
                </div>
            )}
        </div>
    );
}
